import {AMBROSIA_URL} from '../../helpers/auth-header'
import Axios from 'axios'


export default{

    /**
     * Register customer
     *
     * @param e
     * @param dispatch
     * @param state
     * @returns {Promise<void>}
     */
    RegisterCustomer({state , dispatch},e){
        let postData = {
            firstNames: e.target.firstNames.value,
            lastNames: e.target.lastNames.value,
            email: e.target.email.value,
            phone: e.target.phone.value,
            mobile: e.target.mobile.value,
            password: e.target.password.value,
            passwordConfirmation: e.target.passwordConfirmation.value,
            referralCode: e.target.referralCode.value,
            marketingStrategy: e.target.marketingStrategy.value
        }
        Axios.post(AMBROSIA_URL + '/web/register',postData)
        .then(response =>{
            dispatch('LoginCustomer', e)
        })
        .catch(error => {
            dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': error.response.data.errors })
        })
    },


    /**
     * Login customer
     *
     * @param commit
     * @param e
     * @returns {Promise<void>}
     */
    LoginCustomer({commit, state,dispatch},e){
        dispatch('ShowLoadingToast', {'text': 'Iniciando sesión' })
        let postData = {
            username:e.target.email.value,
            password:e.target.password.value,
            tokenType:state.tokenType,
            appId:state.appId,
            appVersion:state.appVersion
        }
        Axios.post(AMBROSIA_URL + '/authorization/get-token',postData)
        .then(response =>{
            const token = response.data.data;
            localStorage.setItem('authToken', token);
            Axios.defaults.headers.common["Authorization"] = token;
            return Axios.get( AMBROSIA_URL+ '/authorization/current-customer')
        })
        .then( response => {
            dispatch('SetCustomer',response.data.data)
        })
        .catch(error => {
            dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': error.response.data.errors })
        })
    },

     /**
     * Set customer token
     *
     * @param commit
     * @param dispatch
     * @param commit
     * @param customer
     * @returns {Promise<void>}
     */
    SetCustomer({state,dispatch,commit}, customer){
        commit('StateAssign', { currentCustomer: customer})
        dispatch('ShowToast', { 'icon':'success', 'title':'Sesión iniciada'})

        if(state.loginFromCart){
            dispatch('RouterPush','confirmar-compra')
            state.loginFromCart = false
        }else{
            dispatch('RouterPush','/')
        }
    },
    /**
     * LogOut Customer
     * @param state
     * @param commit
     * @param dispatch
     * @returns {Promise<void>}
     */
    LogOut({state,commit,dispatch}){
        commit( 'StateAssign', { currentCustomer: null } )
        localStorage.removeItem('authToken');
        delete Axios.defaults.headers.common["Authorization"];
        dispatch('ShowToast', { 'icon':'success', 'title':'Sesión cerrada'})
        dispatch('RouterPush','/')
    },   

    /**
     * Recover Customer Password 
     * @param state
     * @param dispatch
     * @returns {Promise<void>}
     */
    RecoverPassword({state,dispatch},data){
        let postData = {
            customerId:data.customerId,
            passwordRecoveryCode:data.passwordRecoveryCode,
            newPassword:data.formContent.target.newPassword.value,
            newPasswordConfirmation:data.formContent.target.newPasswordConfirmation.value
        }
        Axios.post(AMBROSIA_URL + '/recovery/new-password',postData)
        .then(response => {
            dispatch('ShowToast', { 'icon':'success', 'title':'Se ha cambiado su contraseña'})
        })
        .catch(error => {
            dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': error.response.data.errors })
        })
    },

    /**
     * Forgot Password 
     * @param state 
     * @returns {Promise<void>}
     */
    ForgotPassword({state,dispatch},e){
        let postData = {
            email:e.target.email.value
        }
        Axios.post(AMBROSIA_URL + '/recovery/request-password-recovery',postData)
        .then(response => {
            dispatch('ShowToast', { 'icon':'success', 'title':'Email enviado'})
        })
        .catch(error => {
            dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': error.response.data.errors })
        })
    }, 

    /**
     * Recover User Call
     * @param state 
     * @returns {Promise<void>}
     */
    RecoverUserCall({state, dispatch},e){
        let postData = {
            email:e.target.email.value,
            phone:e.target.phone.value,
            mobile:e.target.mobile.value
        }
        Axios.post(AMBROSIA_URL + '/recovery/request-user-recovery',postData)
        .then(response => {
            document.querySelectorAll("[data-phone]").forEach( function( el ){ el.value = e.target.phone.value; } )
            document.querySelectorAll("[data-email]").forEach( function( el ){ el.value = e.target.email.value; } )
            document.querySelectorAll("[data-mobile]").forEach( function( el ){ el.value = e.target.mobile.value; } )
            document.querySelector('input[name="checkCode"]').disabled = false
        })
        .catch(error => {
            dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': error.response.data.errors })
        })
    },
    
    /**
     * Recover User code
     * @param state
     * @param dispatch
     * @returns {Promise<void>}
     */
    RecoverUserCode({state,dispatch},e){
        let postData = {
            code:e.target.code.value,
            email:e.target.email.value,
            phone:e.target.phone.value,
            mobile:e.target.mobile.value
        }
        Axios.post(AMBROSIA_URL + '/recovery/validate-code',postData)
        .then(response => {
            let passwordRecoveryCode = response.data.data.passwordRecoveryCode
            let customerId = response.data.data.customerId
            if(response.status === 200){
                dispatch('RouterPush','/recuperar'+'/new-password?'+'customerId='+customerId+'&'+'passwordRecoveryCode='+passwordRecoveryCode)
            }
        })
        .catch(error => {
            dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': error.response.data.errors })
        })
    } 
}